import { render, staticRenderFns } from "./events.vue?vue&type=template&id=705d79d0&class=app-bg-login&"
import script from "./events.vue?vue&type=script&lang=ts&"
export * from "./events.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports